var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: { classes: "fadeInDown", delay: 0, duration: 300 },
          expression: "{ classes: 'fadeInDown', delay: 0, duration: 300 }",
        },
      ],
      staticClass: "automation-webhook-details",
    },
    [
      _c("section", [
        _c("span", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("automation.catchAllWebhooks"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "url-container" }, [
          _c("div", { staticClass: "url-label" }, [
            _vm._v(
              _vm._s(_vm.$t("auto.automationWebhookDetailsStandartWebhookUrl"))
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "url" },
            [
              _c("a-input", {
                attrs: { value: _vm.getWebhookURL(), disabled: "" },
              }),
              _vm._v(" "),
              _c("SupsisButton", { on: { click: _vm.copyWebhookURL } }, [
                _vm._v(_vm._s(_vm.$t("auto.automationWebhookDetailsKopyala"))),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "url-container" }, [
          _c("div", { staticClass: "url-label" }, [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "auto.automationWebhookDetailsBeklemeYanTUrlRespondToWebhookZelliIKullanLdNda"
                )
              )
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "url" },
            [
              _c("a-input", {
                attrs: { value: _vm.getWebhookURLWithWaiting(), disabled: "" },
              }),
              _vm._v(" "),
              _c("SupsisButton", { on: { click: _vm.copyResponseURL } }, [
                _vm._v(_vm._s(_vm.$t("auto.automationWebhookDetailsKopyala"))),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(0),
        ]),
      ]),
      _vm._v(" "),
      _c("a-divider"),
      _vm._v(" "),
      _c(
        "section",
        [
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("automation.webhookDataExPreview"))),
          ]),
          _vm._v(" "),
          _c("vue-json-pretty", { attrs: { data: _vm.getWebhookData() } }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "url-description" }, [
      _c("i", [
        _vm._v(
          'Not: Eğer otomasyon içinde "Respond to Webhook" bloğu kullanıyorsanız, bu URL\'yi kullanmalısınız.'
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }